import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { isStaff } from '@/lib/types';
import { Icon } from '@/ui';
import { TextField, pbError } from './ui';

export function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = React.useState('');
  const [password, setPassword] = React.useState('');
  const [error, setError] = React.useState('');
  const [busy, setBusy] = React.useState(false);

  React.useEffect(() => {
    if (isStaff(user)) navigate('/admin', { replace: true });
  }, [user, navigate]);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setBusy(true);
    try {
      await login(email.trim(), password);
      navigate('/admin', { replace: true });
    } catch (err) {
      setError(pbError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="ar-admin" style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--surface-page)', padding: 24 }}>
      <div style={{ width: '100%', maxWidth: 400 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, justifyContent: 'center', marginBottom: 24 }}>
          <span style={{ display: 'inline-flex', color: 'var(--primary-200)' }}><Icon name="shield" size={26} /></span>
          <span style={{ fontWeight: 800, fontSize: 20, color: 'var(--text-100)', letterSpacing: '-0.02em' }}>Aria Admin</span>
        </div>
        <form onSubmit={submit} style={{ background: 'var(--surface-card)', border: '1px solid var(--border-subtle)', borderRadius: 'var(--radius-lg)', padding: 28, boxShadow: 'var(--shadow-md)' }}>
          <h1 style={{ fontSize: 20, fontWeight: 700, color: 'var(--text-100)', margin: '0 0 4px' }}>Anmelden</h1>
          <p style={{ fontSize: 14, color: 'var(--text-200)', margin: '0 0 22px' }}>Zugang nur für berechtigte Mitarbeiter.</p>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            <TextField label="E-Mail" type="email" value={email} onChange={setEmail} placeholder="name@aria-robotics.xyz" required autoFocus />
            <TextField label="Passwort" type="password" value={password} onChange={setPassword} placeholder="••••••••" required />
          </div>
          {error && (
            <div style={{ marginTop: 16, padding: '10px 12px', background: 'rgba(229,72,77,0.10)', border: '1px solid rgba(229,72,77,0.3)', borderRadius: 'var(--radius-sm)', color: '#e5484d', fontSize: 13.5 }}>
              {error}
            </div>
          )}
          <button type="submit" disabled={busy} style={{ marginTop: 22, width: '100%', padding: '12px 16px', borderRadius: 'var(--radius-pill)', border: 'none', background: 'var(--primary-200)', color: '#fff', fontSize: 15, fontWeight: 600, cursor: busy ? 'default' : 'pointer', opacity: busy ? 0.7 : 1, fontFamily: 'var(--font-sans)' }}>
            {busy ? 'Anmelden…' : 'Anmelden'}
          </button>
        </form>
      </div>
    </div>
  );
}
